import { type GenericObject } from '../types';

// tranformer to support multiple versions
export const eventsPayloadTransformer = (version: string, payload: GenericObject): GenericObject =>
  version == '1.0.0'
    ? {
        ...payload,
        version: '1.0.0',
      }
    : payload;

export default eventsPayloadTransformer;
